import { Dispatch } from "redux";
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import jwtAxios from "../../@crema/services/auth/jwt-auth";
import { AppActions } from "types";
import { GET_APPELLATE } from "types/actions/appellateMaster.action";

  export const getAllAppellates = (
  ) => {
    return (dispatch: Dispatch<AppActions>) => {
      dispatch(fetchStart());
      jwtAxios
        .get("appellateMessage", {
          
        })
        .then((response) => {
          if (response.status === 200) {
            dispatch(fetchSuccess());
            dispatch({ type: GET_APPELLATE, payload: response.data.data });
          } else {
            dispatch(fetchError("Something went wrong, Please try again!"));
          }
        })
        .catch((error) => {
          dispatch(fetchError(error.message));
        });
    };
  };
  
  